<template>
    <Header></Header>
    <LocationBar></LocationBar>
    <div class="container">
        <div class="sub-tit">
            <h2>퍼블리싱 샘플 모음</h2>
        </div>
        <div class="inner">
            <Sample></Sample>
        </div>
    </div>
    <Footer></Footer>
</template>

<script>
    import Header from '@/components/common/Header.vue';
    import LocationBar from '@/components/common/LocationBar.vue';
    import Sample from '@/components/퍼블팀/샘플/Sample.vue';
    import Footer from '@/components/common/Footer.vue';

    export default {
        components: {
            Header,
            LocationBar,
            Sample,
            Footer
        },
        mounted() {
            console.log(123)
        },
    }
</script>
<style>
    /* @import url('../../assets/resource/css/sub.css'); */
</style>